//import 'url-search-params-polyfill';

export default {
  init() {

    //const urlParams = new URLSearchParams(window.location.search);

    if($('.woocommerce-variation.single_variation').length ) {
      $('.woocommerce-variation-add-to-cart').show();
      setTimeout(function () {
        $('.woocommerce-variation.single_variation').show();


        // Select the node that will be observed for mutations
        const targetNode = $('.woocommerce-variation.single_variation')[0];

        // Options for the observer (which mutations to observe)
        const config = { attributes: true, childList: true, subtree: true };

        // Callback function to execute when mutations are observed
        const callback = function () {
          // Use traditional 'for loops' for IE 11

          $('.woocommerce-variation.single_variation').show();
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
      }, 1000);

      // If cart is not enabled (this would be if the page was reloaded and options were already in place) then hide all options after the first.
      // If there is a query var then don't hide also as this is needed for google feed links that have query vars for auto selecting products.
      // if ($('.variations_button woocommerce-variation-add-to-cart-enabled').length == 0 && !urlParams.get('attribute_pa_size')) {
      //   $('.variations .value:not(:first)').hide();
      //   $('.variations .label:not(:first)').hide();
      // }

      $('.variations_form').on('change.custom-express', function () {
        $('.variations .value:not(:first)').show();
        $('.variations .label:not(:first)').show();
        $('.variations_form').off('change.custom-express');
      });
    }



  },

}



// WEBPACK FOOTER //
// ./scripts/components/toggle-variations.js